import { render } from "./AdminLoginForm.vue?vue&type=template&id=516bd0c4&scoped=true"
import script from "./AdminLoginForm.vue?vue&type=script&lang=js"
export * from "./AdminLoginForm.vue?vue&type=script&lang=js"

import "./AdminLoginForm.vue?vue&type=style&index=0&id=516bd0c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516bd0c4"]])

export default __exports__